import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const applyCouponHandler: ActionHandler = {
  type: 'apply_coupon',
  execute(ctx) {
    const config = ctx.config;
    const couponCode = readString(config, 'couponCode', 'coupon_code');
    if (!couponCode) {
      return {
        status: 'failed',
        reason: 'missing_coupon_code',
      };
    }
    const port = ctx.semanticPorts?.applyCoupon;
    return invokeSemanticPort(
      ctx,
      'apply_coupon',
      port ? (context) => port({ couponCode }, context) : undefined
    );
  },
};
